export default class ImagesDataProvider {
  constructor(Images) {
    "ngInject"
    this.ImagesService = Images;
  }

  getCategory(data) {
    return this.ImagesService.loadCategories(data)
      .then((categories) => {
        return categories;
      })
  }

  saveCategory(data) {
    return this.ImagesService
      .saveCategory(data)
      .then((resp) => {
        return resp;
      })
  }

  removeCategory(id) {
    return this.ImagesService
      .removeCategory(id)
      .then((resp) => {
        return resp;
      })
  }

  getCategoryById(id) {
    return this.ImagesService.categoryById(id)
      .then((resp) => {
        return resp;
      })
  }

  updateCategory(data) {
    return this.ImagesService
      .updateCategory(data)
      .then((resp) => {
        return resp;
      })
  }

  getImages(data) {
    return this.ImagesService.getImages(data)
      .then((result) => {
        return result;
      })
  }

  getImage(id) {
    return this.ImagesService.getImage(id)
      .then((result) => {
        return result;
      })
  }

  loadCategoriesNoLimit() {
    return this.ImagesService.loadCategoriesNoLimit()
      .then((categories) => {
        return categories;
      })
  }

  removeImage(id) {
    return this.ImagesService
      .removeImage(id)
      .then((resp) => {
        return resp;
      })
  }

  updateData(data) {
    return this.ImagesService
      .updateData(data)
      .then((resp) => {
        return resp;
      })
  }

  updateImageOrder(data) {
    return this.ImagesService
      .updateImageOrder(data)
      .then((resp) => {
        return resp;
      })
  }

  updateImageData(data) {
    return this.ImagesService
      .updateImageData(data)
      .then((resp) => {
        return resp;
      })
  }

  checkRecordExist(data) {
    return this.ImagesService
      .checkRecordExist(data)
      .then((resp) => {
        return resp;
      })
  }

  saveImageData(data) {
    return this.ImagesService
      .saveImageData(data)
      .then((resp) => {
        return resp;
      })
  }


}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/images/services/images.dataprovider.service.js
 **/